import React, { Component } from 'react';
import { Modal, Form, Input, Button, Steps, message, Progress, Col, Icon, Select, Row, Dropdown, Menu, Tag, Spin, Popover } from 'antd';
import { DateRangePicker } from "react-dates";
import moment from "moment";
import {
    VERTICAL_ORIENTATION,
    HORIZONTAL_ORIENTATION,
    OPEN_UP
} from "react-dates/constants";
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import Colors from "../themes/Colors";
import { CSSTransition } from 'react-transition-group';
import CSSEffect from './Styles/CSSEffect'
import { getMinimunByCurrency } from "../services/utils";
import CampaignProposals from './CampaignProposals';
import AILoader from './AILoader';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import DisplayActions from '../redux/DisplayRedux';
import UserAccountActions from "../redux/UserAccountRedux";
import ChatbotActions from './features/ia_chatbot/redux/ChatbotRedux';
import { Tooltip } from 'antd';
import logoLatinAdAI from "../images/LOGO-IA-LATINAD.png";
import fondo from "../images/fondo_red_tecnologica.png";
import logoFenix from "../images/whiteLabel/fenix-publinet.png";
import logoGrupovia from "../images/whiteLabel/grupo-via.svg";
import logoMediaShake from "../images/whiteLabel/media-shake.png";
import logoSmartFit from "../images/whiteLabel/smart-fit.png";
import logoDuoPrint from "../images/whiteLabel/duo-print.png";
import logoTerritorioDigital from "../images/whiteLabel/territorio-digital.png";
import logoMovImagen from "../images/whiteLabel/movimagen.png";
import logoYoda from "../images/whiteLabel/yoda.png";
import logoHakMedia from "../images/whiteLabel/hak-media.png";
import logoBlaster from "../images/whiteLabel/blaster.png";
import logoLaMediatica from "../images/whiteLabel/laMediatica.png";
import logoDv360 from "../images/whiteLabel/dv360.png";
import { convertBounds } from '../services/display';
import { getDomain } from '../services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
const domain = getDomain(window.location.hostname);
const isLatinAd = domain === 'latinad';

const whiteLabelLogos = {
  latinad: logoLatinAdAI,
  fenix: logoFenix,
  grupoVia: logoGrupovia,
  mediaShake: logoMediaShake,
  smartFit: logoSmartFit,
  duoPrint: logoDuoPrint,
  territorioDigital: logoTerritorioDigital,
  movImagen: logoMovImagen,
  yoda: logoYoda,
  hakMedia: logoHakMedia,
  blaster: logoBlaster,
  laMediatica: logoLaMediatica,
  dv360: logoDv360,
};

const modalLogo = whiteLabelLogos[domain] || logoLatinAdAI;

const mapStateToProps = (state) => ({
    invoiceIssuingCountry: state.userAccount.invoiceIssuingCountry,
    countries: state.userAccount.countries,
    planner: state.display.planner,
    proposals: state.display.proposals,
    justifications: state.display.justifications,
    loadingJustifications: state.display.loadingJustifications,
    campaign_categories: state.display.campaign_categories,
    campaign_POI: state.display.campaign_POI,
    campaign_screens: state.display.campaign_screens,
    client: state.display.client,
    cart: state.display.cart,
    amountBudget: state.display.amountBudget,
    campaignName: state.display.campaignName,
    categoriesId: state.display.categoriesId,
    campaignDescription: state.display.campaignDescription,
    loading: state.display.loading,
    proposalsErrors: state.display.proposalsErrors,
});

const mapDispatchToProps = (dispatch) => ({
    createProposalsRequest: (id, params) => dispatch(DisplayActions.createProposalsRequest(id, params)),
    justifyPlannerRequest: (params) => dispatch(DisplayActions.justifyPlannerRequest(params)),
    getCampaignCategoriesRequest: () => dispatch(DisplayActions.getCampaignCategoriesRequest()),
    getCampaignPOIRequest: () => dispatch(DisplayActions.getCampaignPOIRequest()),
    getCampaignScreensRequest: () => dispatch(DisplayActions.getCampaignScreensRequest()),
    clearProposals: () => dispatch(DisplayActions.clearProposals()),
    clearPlanner: () => dispatch(DisplayActions.clearPlanner()),
    setSelectedProposalId: (proposalId) => dispatch(DisplayActions.setSelectedProposalId(proposalId)),
    toggleCampaignFormModal: (visible) => dispatch(DisplayActions.toggleCampaignFormModal(visible)),
    addListDisplayToCart: (displays) => dispatch(DisplayActions.addListDisplayToCart(displays)),
    removeDisplaysCart: () => dispatch(DisplayActions.removeDisplaysCart()),
    getDisplaysCart: params => dispatch(DisplayActions.getDisplaysCartRequest(params)),
    setBudget: (amountBudget) => dispatch(DisplayActions.setBudget(amountBudget)),
    setCampaignName: (campaignName) => dispatch(DisplayActions.setCampaignName(campaignName)),
    setCategoriesId: (categoriesId) => dispatch(DisplayActions.setCategoriesId(categoriesId)),
    setCampaignDescription: (campaignDescription) => dispatch(DisplayActions.setCampaignDescription(campaignDescription)),
    setCampaignBillingInfo: (currency, billingCountry, invoiceIssuingCountry)=> dispatch(DisplayActions.setCampaignBillingInfo(currency, billingCountry, invoiceIssuingCountry)),
    setBilling: (currency, country, codeCountry)=> dispatch(UserAccountActions.setBilling(currency, country, codeCountry)),
    openChatbotWithGreeting: (text) => dispatch(ChatbotActions.openWithGreeting(text)),
});

const { Step } = Steps;

class CampaignFormModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            focusedInput: null,
            initialized: false,
            start_date: null,
            end_date: null,
            campaign_zones: [],
            campaign_zonesLatLng: [],
            address: '',
            latLng: null,
            campaign_category: null,
            campaign_amount: 0,
            currency: null,
            currencies: [],
            male_percentage: 0,
            female_percentage: 0,
            socioeconomic_a_percentage: 0,
            socioeconomic_b_percentage: 0,
            socioeconomic_c_percentage: 0,
            socioeconomic_d_percentage: 0,
            socioeconomic_e_percentage: 0,
            age_children: 0,
            age_teens: 0,
            age_young_adults: 0,
            age_midlife_adults: 0,
            age_mature_adults: 0,
            age_seniors: 0,
            points_of_interest: [],
            screen_types: [],
            screen_subtypes: [],
            isLoaderFinished: false,
            showProposals: false,
            date_justification: null,
            budget_justification: null,
            audience_justification: null,
            location_justification: null,
            strategy_justification: null,
        };

        this.props.clearPlanner();
        this.props.clearProposals();
        this.props.toggleCampaignFormModal(false);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleCreateProposals = (plannerFormAI) => {
        const params = { user_modified_json: plannerFormAI }
        this.props.setBudget(this.state.campaign_amount)
        this.props.createProposalsRequest(this.props.planner.id, params);

        
    }

    handleLoaderFinish = () => {
        this.setState({ isLoaderFinished: true });
    };

    componentDidMount() {
        this.initializeFormWithPlannerData();
    }

    getCurrencies() {
        const { countries, invoiceIssuingCountry } = this.props;
        const selectedCountry = countries.find(
            (c) => c.alpha_2_code === invoiceIssuingCountry
        );
        let availableCurrencies = [];
        if (selectedCountry) {
            availableCurrencies = [
                {
                code: selectedCountry.default_currency.code,
                description: selectedCountry.default_currency.description,
                },
                ...(selectedCountry.currencies || []),
            ];
        }
        this.setState({ currencies: availableCurrencies });
    }

    componentDidUpdate(prevProps) {
        const hadNoProposals = !(prevProps.proposals && prevProps.proposals.proposals && prevProps.proposals.proposals.length);
        const hasProposals = this.props.proposals && this.props.proposals.proposals && this.props.proposals.proposals.length > 0;
        const hasErrors = this.props.proposals && this.props.proposalsErrors;

        if (prevProps.loading && !this.props.loading && hasErrors) {
            message.error(this.props.t('There was an error'), 10);
        }
        
        if (hadNoProposals && hasProposals) {
            this.setState({ loading: false });
            this.next();
        }

        if (this.props.planner && prevProps.planner !== this.props.planner) {
            this.getCurrencies();
            this.initializeFormWithPlannerData();
            if (this.props.planner.id) {
                this.props.justifyPlannerRequest({ planner_run_id: this.props.planner.id });
            }
        }

        if (this.props.justifications && prevProps.justifications !== this.props.justifications) {
            const j = this.props.justifications;
            this.setState({
                date_justification: j.date_justification || null,
                budget_justification: j.budget_justification || null,
                audience_justification: j.audience_justification || null,
                location_justification: j.location_justification || null,
                strategy_justification: j.strategy_justification || null,
            });
        }
    }

    saveCoordinatesForZones = async (zones) => {
        if (!zones || zones.length === 0) return;

        const geocodingPromises = zones.map(zone => 
            geocodeByAddress(zone)
                .then(results => convertBounds(results[0].geometry.viewport))
                .catch(error => null)
        );
        
        const results = await Promise.all(geocodingPromises);
        
        const zonesLatLng = results.map(result => result);
        
        return zonesLatLng;
    };

    initializeFormWithPlannerData = async () => {
        const plannerData = this.props.planner;
        if (plannerData && plannerData.ai_generated_json && plannerData.ai_generated_json.toString().length > 2) {
            const plannerFormAI = JSON.parse(plannerData.ai_generated_json);

            const zonesLatLng = await this.saveCoordinatesForZones(plannerFormAI.campaign_zones);
            this.setState({
                start_date: plannerFormAI.start_date ? moment(plannerFormAI.start_date) : null,
                end_date: plannerFormAI.end_date ? moment(plannerFormAI.end_date) : null,
                campaign_zones: plannerFormAI.campaign_zones,
                campaign_zonesLatLng: zonesLatLng,
                campaign_category: plannerFormAI.campaign_category[0],
                campaign_amount: plannerFormAI.campaign_amount,
                currency: plannerFormAI.currency,
                male_percentage: plannerFormAI.male_percentage,
                female_percentage: plannerFormAI.female_percentage,
                socioeconomic_a_percentage: plannerFormAI.socioeconomic_a_percentage,
                socioeconomic_b_percentage: plannerFormAI.socioeconomic_b_percentage,
                socioeconomic_c_percentage: plannerFormAI.socioeconomic_c_percentage,
                socioeconomic_d_percentage: plannerFormAI.socioeconomic_d_percentage,
                socioeconomic_e_percentage: plannerFormAI.socioeconomic_e_percentage,
                age_children: plannerFormAI.age_children,
                age_teens: plannerFormAI.age_teens,
                age_young_adults: plannerFormAI.age_young_adults,
                age_midlife_adults: plannerFormAI.age_midlife_adults,
                age_mature_adults: plannerFormAI.age_mature_adults,
                age_seniors: plannerFormAI.age_seniors,
                points_of_interest: plannerFormAI.points_of_interest ? [...this.props.campaign_POI.filter(p => plannerFormAI.points_of_interest .includes(p.type)) .map(p => p.type)] : [],
                screen_types: plannerFormAI.screen_types,
                screen_subtypes: plannerFormAI.screen_subtypes ? [...plannerFormAI.screen_subtypes.map(item => item.split("|")[0])] : [],
                date_justification: plannerFormAI.date_justification || null,
                budget_justification: plannerFormAI.budget_justification || null,
                audience_justification: plannerFormAI.audience_justification || null,
                location_justification: plannerFormAI.location_justification || null,
                strategy_justification: plannerFormAI.strategy_justification || null,
            });
        }
    };

    setDates = ({ startDate, endDate }) => {
        this.setState({start_date: startDate, end_date: endDate});
    };

    next = () => {
        const { current } = this.state;
        this.setState({ current: current + 1 });
    };

    prev = () => {
        const { current } = this.state;
        this.setState({ current: current - 1 });
    };

    handleFormChange = (e, field, t) => {
        let value = e.target.value;
        const parsedValue = value === '' ? 0 : parseFloat(value);
        const finalValue = Math.min(100, Math.max(0, parsedValue));

        if (field === 'male_percentage') {
            const femaleValue = 100 - finalValue;
            this.setState({
                male_percentage: String(finalValue),
                female_percentage: String(femaleValue)
            });
        } else if (field === 'female_percentage') {
            const maleValue = 100 - finalValue;
            this.setState({
                male_percentage: String(maleValue),
                female_percentage: String(finalValue)
            });
        } else {
            this.setState({ [field]: value });
        }
    };

    handleAgeFormChange = (e, field, t) => {
        const ageKeys = ['age_children', 'age_teens', 'age_young_adults', 'age_midlife_adults', 'age_mature_adults', 'age_seniors'];
        const newAges = { ...this.state };
        const parsedValue = parseFloat(e.target.value);
        if (parsedValue === 100) {
            ageKeys.forEach(ageKey => {
                if (ageKey === field) {
                    newAges[ageKey] = 100;
                } else {
                    newAges[ageKey] = 0;
                }
            });
            this.setState(newAges);
            return;
        }
        if (isNaN(parsedValue)) {
            newAges[field] = 0;
        } else {
            newAges[field] = String(Math.min(100, Math.max(0, parsedValue)));
        }

        const currentTotal = ageKeys.reduce((acc, currentKey) => {
            const val = parseFloat(newAges[currentKey]);
            return acc + (isNaN(val) ? 0 : val);
        }, 0);
        const difference = 100 - currentTotal;
        
        if (difference !== 0 && !isNaN(difference) && newAges[field] !== '') {
            const changedIndex = ageKeys.indexOf(field);    
            const nextIndex = (changedIndex + 1) % ageKeys.length;
            const nextKey = ageKeys[nextIndex];
            
            let nextValue = parseFloat(newAges[nextKey]);
            if (isNaN(nextValue)) {
                nextValue = 0;
            }

            const newNextValue = Math.min(100, Math.max(0, nextValue + difference));
            newAges[nextKey] = String(newNextValue);
        }
        
        this.setState(newAges);
    };

    handleLevelFormChange = (e, field, t) => {
        const levelKeys = ['socioeconomic_a_percentage', 'socioeconomic_b_percentage', 'socioeconomic_c_percentage', 'socioeconomic_d_percentage', 'socioeconomic_e_percentage'];
        const newLevels = { ...this.state };
        const parsedValue = parseFloat(e.target.value);
        if (parsedValue === 100) {
            levelKeys.forEach(ageKey => {
                if (ageKey === field) {
                    newLevels[ageKey] = 100;
                } else {
                    newLevels[ageKey] = 0;
                }
            });
            this.setState(newLevels);
            return;
        }
        if (isNaN(parsedValue)) {
            newLevels[field] = 0;
        } else {
            newLevels[field] = String(Math.min(100, Math.max(0, parsedValue)));
        }

        const currentTotal = levelKeys.reduce((acc, currentKey) => {
            const val = parseFloat(newLevels[currentKey]);
            return acc + (isNaN(val) ? 0 : val);
        }, 0);
        const difference = 100 - currentTotal;
        
        if (difference !== 0 && !isNaN(difference) && newLevels[field] !== '') {
            const changedIndex = levelKeys.indexOf(field);    
            const nextIndex = (changedIndex + 1) % levelKeys.length;
            const nextKey = levelKeys[nextIndex];
            
            let nextValue = parseFloat(newLevels[nextKey]);
            if (isNaN(nextValue)) {
                nextValue = 0;
            }

            const newNextValue = Math.min(100, Math.max(0, nextValue + difference));
            newLevels[nextKey] = String(newNextValue);
        }
        
        this.setState(newLevels);
    };

    handleSelect = async (address) => {
        const newZones = [...this.state.campaign_zones, address];
        const latLng = await this.saveCoordinatesForZones([address]);        

        this.setState({
            campaign_zones: newZones,
            campaign_zonesLatLng: [...this.state.campaign_zonesLatLng, ...latLng],
        });
    };

    handleChange = (address) => {
        this.setState({ address });
    };

    handleScreenTypesChange = (selectedTypes) => {
        this.setState((prevState, props) => {
            const validSubtypes = prevState.screen_subtypes.filter(subtypeName => {
                const subtypeObj = props.campaign_screens.find(s => s.name_en === subtypeName);
                return subtypeObj && selectedTypes.includes(subtypeObj.parent_latinad);
            });

            return {
            screen_types: selectedTypes,
            screen_subtypes: validSubtypes
            };
        });
    };

    handleScreenSubtypesChange = (newSubtypes) => {
        this.setState({ screen_subtypes: newSubtypes });
    };

    handleScreenPOIChange = (newPOI) => {
        this.setState({ points_of_interest: newPOI });
    };

    removeZone = (index) => {
        this.setState(prevState => ({
            campaign_zones: prevState.campaign_zones.filter((_, i) => i !== index)
        }));
    };


    renderBrainIcon = (justification) => {
        if (!justification) return null;
        const content = (
            <div style={{ maxWidth: 340, padding: '4px 2px' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8,
                    marginBottom: 10,
                    paddingBottom: 8,
                    borderBottom: `1px solid ${Colors.primaryAccent}55`,
                }}>
                    <FontAwesomeIcon icon={faBrain} style={{ color: Colors.primaryAccent, fontSize: '15px', flexShrink: 0, marginTop: 2 }} />
                    <span style={{ color: Colors.primaryAccent, fontWeight: 600, fontSize: '13px', lineHeight: 1.4 }}>
                        {justification.question}
                    </span>
                </div>
                <p style={{ margin: 0, fontSize: '12px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.6 }}>
                    {justification.answer}
                </p>
            </div>
        );
        return (
            <Popover content={content} trigger="hover" overlayStyle={{ maxWidth: 360 }} overlayClassName="brainPopover">
                <span
                    style={{ marginLeft: 6, cursor: 'default', color: Colors.primaryAccent, display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', opacity: 1, transition: 'opacity 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                >
                    <FontAwesomeIcon icon={faBrain} style={{ fontSize: '14px' }} />
                </span>
            </Popover>
        );
    };
    

    customStyles = `
    .brainPopover .ant-popover-inner {
        background: ${isLatinAd ? '#1a1a2e' : Colors.background};
        border: 1px solid ${Colors.primaryAccent}66;
        border-radius: 10px;
        box-shadow: 0 4px 20px ${Colors.primary}33;
    }
    .brainPopover .ant-popover-inner-content {
        color: ${isLatinAd ? 'rgba(255,255,255,0.85)' : Colors.coal};
    }
    .brainPopover.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,
    .brainPopover.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,
    .brainPopover.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow,
    .brainPopover.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,
    .brainPopover.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,
    .brainPopover.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
        border-top-color: ${isLatinAd ? '#1a1a2e' : Colors.background};
        border-bottom-color: ${isLatinAd ? '#1a1a2e' : Colors.background};
    }
    .ant-modal-wrap:has(.customModal) {
        display: flex;
        align-items: center;
    }
    .ant-select-dropdown-menu:has(.selectAI), .ant-dropdown-menu:has(.selectAI) {
        background: ${isLatinAd ? 'black' : Colors.background} !important;
        color: ${isLatinAd ? 'white' : Colors.coal};
        .ant-select-dropdown-menu-item-selected, .ant-select-dropdown-menu-item-active, .ant-dropdown-menu-item-selected, .ant-dropdown-menu-item-active  {
            background: ${Colors.primary};
            color: ${Colors.onPrimary} !important;
        }
        .ant-select-dropdown-menu-item, .ant-dropdown-menu-item {
            color: ${isLatinAd ? 'white' : Colors.coal};
            &:hover {
                background: ${Colors.primary};
                color: ${Colors.onPrimary};
            }
        }
    }
    .customModal {
        top: 0;
        padding: 0;
        .ant-modal-content {
            ${isLatinAd
                ? `background-image: url(${fondo}); background-repeat: no-repeat; background-size: cover; background-position: center center;`
                : `background: ${Colors.background};`
            }
            color: ${isLatinAd ? 'white' : Colors.coal};
            border-radius: 16px !important;
        }
        .contentStyle {
            lineHeight: '260px',
            textAlign: 'center',
            marginTop: 16,
        }
        .ant-modal-wrap{
            height: 100vh;
            display: flex;
            align-items: center;
        }
        .ant-modal-content {
            padding: 0;
        }
        .ant-steps-item-title {
            font-weight: bold;
        }
        .bodyDiv {
            overflow-y: auto;
            max-height: 600px;
            padding: 10px;
            border-width: 2px 2px 0px 2px;
            border-style: solid;
            border-radius: 14px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            border-color: ${Colors.primaryAccent};
        }
        .ant-progress-outer {
            padding: 0px !important;
        }
        .modal-title {
            height: auto;
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
        }
            
        .marginInputModal {
            margin: 0 0 20px 0px;

            @media (max-width: 480px) {
            margin: 0 0 20px 0px;
            }
        }
        .datePicker {
            margin: 0 0 20px 0;
            display: flex;
            flex-direction: column;
            right: 1px;
            z-index: 2;

            @media (min-width: 480px) {
            flex-direction: row;
            }
            @media (max-width: 575px) {
            margin: 0 0 20px 0;
            }
        }
        .calendarIcon {
            left: 21px;
            top: -10px;
            position: absolute;
            z-index: 1;
            font-size: 15px;
            color: ${Colors.primaryAccent};;
            padding-top: 9px;
        }
        .dateStartTitle {
            left: 54px;
            top: -10px;
            position: absolute;
            z-index: 1;
            font-size: 12px;
            color: ${isLatinAd ? 'white' : Colors.coal};
        }
        .dateEndTitle {
            left: 50.2%;
            top: -10px;
            position: absolute;
            z-index: 1;
            font-size: 12px;
            color: ${isLatinAd ? 'white' : Colors.coal};
        }

        .DateRangePickerInput_calendarIcon_svg {
            fill: ${Colors.coal};
        }

        .DateRangePickerInput_calendarIcon:focus {
            outline: none;
        }

        .DateRangePicker {
            width: 100%;
            border-radius: 35px;
        }
        .DateRangePickerInput__withBorder {
            width: 100%;
        }
        .DateInput_input::placeholder {
            color: ${Colors.textMuted};
        }
        .DateInput {
            width: calc(50% - 12px);
            border-radius: 35px;
            height: 60px;
        }
        #your_unique_start_date_id {
            padding-left: 54px;
            padding-top: 25px;
            padding-bottom: 6px;
            height: 60px;
            font-size: 14px;

            border-left: 1px solid ${Colors.borderStrong};
            @media (max-width: 767px) {
            border-bottom-left-radius: 35px;
            border-top-left-radius: 35px;
            }
        }
        #your_unique_end_date_id {
            border-left: 1px solid ${Colors.borderStrong};
            border-top-right-radius: 10px !important;
            border-bottom-right-radius: 10px !important;
            padding-top: 25px;
            padding-bottom: 6px;
            height: 60px;
            font-size: 14px;
        }
        .DateInput_input {
            border-bottom: 0px;
            color: ${Colors.coal};
            font-family: "Poppins", sans-serif;
            font-size: 16px;
        }
        .DateInput_input__focused {
            border-bottom: 0px;
        }
        /* CALENDAR DAY */
        .CalendarDay__selected,
        .CalendarDay__selected:active,
        .CalendarDay__selected:hover {
            background: ${Colors.primary};
            border: 1px solid ${Colors.primary};
            color: ${Colors.white};
        }

        .CalendarDay__selected_span {
            background: ${Colors.lightPrimary};
            border: 1px solid ${Colors.lightPrimary};
        }

        .CalendarDay__selected_span:active,
        .CalendarDay__selected_span:hover {
            background: ${Colors.lightPrimary};
            border: 1px solid ${Colors.lightPrimary};
            color: ${Colors.white};
        }

        .CalendarDay__hovered_span,
        .CalendarDay__hovered_span:hover {
            background: ${Colors.lightPrimary};
            border: 1px solid ${Colors.lightPrimary};
            color: ${Colors.white};
        }

        .DayPickerKeyboardShortcuts_show__bottomRight {
            border-right: 33px solid ${Colors.primaryAccent};
        }

        .DayPickerKeyboardShortcuts_show__bottomRight:hover {
            border-right: 33px solid ${Colors.secondary};
        }

        .DayPicker_transitionContainer.DayPicker_transitionContainer__vertical {
            height: 350px !important;
        }
        .ant-row.ant-form-item {
            margin-bottom: 0;
            padding-bottom: 0;
            label {
                color: ${isLatinAd ? 'white' : Colors.coal} !important;
            }
        }
        .ant-modal-footer {
            padding: 0;
            border-top: 0;
        }
        .footerDiv {
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding: 10px 20px 20px;
            border-width: 0px 2px 2px 2px;
            border-style: solid;
            border-radius: 14px;
            border-top-right-radius: 0;
            border-top-left-radius: 0;
            border-color: ${Colors.primaryAccent};
        }
        .ant-tag, .btnAI {
            background: ${isLatinAd ? 'black' : Colors.background};
            border: 1px solid ${Colors.primaryAccent};
            color: ${Colors.primaryAccent};
            transition: background 0s ease, border-color 0s ease;
        }
        .btnAI:hover {
            background: ${Colors.primary};
            i.anticon.anticon-caret-left.btnActionAI, i.anticon.anticon-caret-right.btnActionAI {
                color: ${Colors.white} !important;
            }
        }
        li.ant-select-selection__choice {
            background: ${isLatinAd ? 'black' : Colors.background};
            border: 1px solid ${Colors.primaryAccent};
            color: ${Colors.primaryAccent};
        }
        .CalendarMonth_caption {
            font-size: 16px
        }
        .DateRangePicker_picker {
            left: 10px !important;
        }
        .ant-steps-item-title, i.anticon:not(.btnActionAI), .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon, span.ant-select-arrow, .cardSubtitleAI {
            color: ${Colors.primaryAccent} !important;
        }
        span.ant-input-group-addon, input.ant-input, .ant-select-selection, input#your_unique_start_date_id, input#your_unique_end_date_id, .DateRangePickerInput {
            background: ${isLatinAd ? 'black' : Colors.background};
            color: ${isLatinAd ? Colors.primary : Colors.coal};
            border-color: ${Colors.primaryAccent};
        }
        .proposalInfo span {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .ant-steps-item-process .ant-steps-item-icon {
            background: ${Colors.primary};
            border: none
        }

        .ant-steps-item-wait .ant-steps-item-icon, .ant-steps-item-finish .ant-steps-item-icon {
            background: ${isLatinAd ? 'black' : Colors.background};
            border: 2px solid ${Colors.primaryAccent};
            color: ${Colors.primaryAccent} !important;
        }
        .ant-steps-item-title::after {
            background: ${Colors.primary} !important;
        }
        .steps-content {
            padding: 0px 10px;
            max-height: 550px;
            overflow-y: auto;
        }
        .iconAI {
            width: 50px;
            height: 24px;
            svg {
                height: 24px;
                width: 24px;
            }
        }
        .btnPropsAI {
            color: ${Colors.white};
            background: ${Colors.primary};
        }
        .ant-card-actions {
            background: ${isLatinAd ? 'black' : Colors.background};
        }
        .ant-card-bordered {
            border: 2px solid ${Colors.primaryAccent}
        }
        .ant-card-head, .ant-card-actions {
            border: none
        }
        i.anticon.iconInfoAI {
            margin-left: 5px;
            color: ${Colors.textMuted} !important;
        }
        .btnActionAI {
            svg {
                width: 24px;
                height: 24px;
            }
        }
        i.anticon.anticon-caret-left.btnActionAI {
            margin: 0px 5px 0px 0px;
            height: 24px;
            &:hover {
                color: ${Colors.white} !important;
            }
        }
        i.anticon.anticon-caret-right.btnActionAI {
            margin: 0px 0px 0px 5px;
            height: 24px;
            &:hover {
                color: ${Colors.white} !important;
            }
        }
        .proposalObj {
            border: 1px solid ${Colors.primaryAccent};
            border-radius: 10px;
            padding: 10px;
            text-align: center;
        }
        .proposalObjs {
            color: ${Colors.primaryAccent};
            font-size: smaller;
            height: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
        .proposalImg {
            border: 1px solid ${Colors.primaryAccent};
            border-radius: 10px;
            margin-bottom: 10px;
            height: 100px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
        }
        .cardShadow {
            box-shadow: 0px 0px 5px 1px ${Colors.primary};
        }
        .ant-card-body {
            padding: 0px 15px;
        }
        .ant-list-grid .ant-col > .ant-list-item {
            margin-bottom: 0;
        }
        .ant-list-grid .ant-col .ant-col {
            padding: 0px 5px;
        }
        hr { margin: 0 !important }
        input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type=number] {
            -moz-appearance: textfield;
        }

        input, select, textarea, .ant-select-selection-selected-value, input.ant-input {
            color: ${isLatinAd ? Colors.extraLightPrimary : Colors.coal} !important;
            font-weight: 700;
        }

        textarea:focus, input:focus {
            color: ${isLatinAd ? Colors.extraLightPrimary : Colors.coal} !important;
            font-weight: 700;
        }

        .DayPicker_transitionContainer, .CalendarMonthGrid, .CalendarMonth, .DayPickerNavigation_button, .CalendarMonth_caption {
            background-color: ${isLatinAd ? 'black' : Colors.background};
            color: ${isLatinAd ? 'white' : Colors.coal};
        }

        .DayPickerNavigation_svg__horizontal {
            fill: ${isLatinAd ? 'white' : Colors.coal};
        }
        ::-webkit-scrollbar {
            width: 12px;
        }
        
        ::-webkit-scrollbar-track {
            border-radius: 8px;
            background-color: ${Colors.gray};
            border: 1px solid ${Colors.borderStrong};
            box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        }
        
        ::-webkit-scrollbar-thumb {
            border-radius: 8px;
            background-color: #363636;
        }
    }
    `;

    steps = (t) => [
        {
            title: t('Campaign Information'),
            subtitle: t('Configure the basic details of your campaign'),
            content: (
                <Form layout="vertical">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="zonePicker" style={{marginBottom: '8px'}}>
                        <Form.Item label={
                            <>
                                <Icon type="environment" className='iconAI' />
                                {t("Campaign location")}
                            </>}>
                            <PlacesAutocomplete
                                value={this.state.address}
                                onChange={this.handleChange}
                                onSelect={this.handleSelect}
                                searchOptions={{componentRestrictions: {
                                }}}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                        <Dropdown
                                            visible={suggestions.length > 0}
                                            trigger={["click"]}
                                            overlay={
                                                <Menu>
                                                    {loading && <Menu.Item key={"loading"}>{t('Loading')}...</Menu.Item>}
                                                    {suggestions.map(suggestion => {
                                                        const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
                                                        return (
                                                            <Menu.Item key={suggestion.placeId} {...getSuggestionItemProps(suggestion, { className })} className='selectAI'>
                                                                <span>{suggestion.description}</span>
                                                            </Menu.Item>
                                                        );
                                                    })}
                                                </Menu>
                                            }
                                        >
                                            <Input
                                                placeholder={t('Add Country or City?')}
                                                {...getInputProps({
                                                    className: "location-search-input"
                                                })}
                                            />
                                        </Dropdown>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="marginInputModal">
                        {this.state.campaign_zones && this.state.campaign_zones.map((zone, index) => (
                            <Tag key={index} closable onClose={() => this.removeZone(index)}>
                                {zone}
                            </Tag>
                        ))}
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='marginInputModal'>
                        <Form.Item label={
                            <>
                                <Icon type="tag" className='iconAI' />
                                {t("Category")}
                                {this.renderBrainIcon(this.state.strategy_justification)}
                            </>
                            }>
                            <Select defaultValue={t("Select")} onChange={(value) => this.setState({ campaign_category: value })} value={this.state.campaign_category} showSearch
                                filterOption={(inputValue, option) => {
                                    const input = inputValue.toLowerCase();

                                    const nameEn = option.props.name_en.toLowerCase();
                                    const nameEs = option.props.name_es.toLowerCase();

                                    return nameEn.includes(input) || nameEs.includes(input);
                                }}
                            >
                                {this.props.campaign_categories && this.props.campaign_categories.map((cat, index) => (
                                    <Select.Option key={index} value={cat.name_en} name_en={cat.name_en} name_es={cat.name_es} className='selectAI'>
                                        {this.props.i18n.language === 'en' ? cat.name_en : cat.name_es}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="datePicker marginInputModal">
                        <Form.Item className='dateModal'>
                            <div className="calendarIcon">
                                <Icon type="calendar" />
                            </div>
                            <div className="dateStartTitle" style={{ display: 'flex', alignItems: 'center' }}>
                                {t('Campaign start')}
                                {this.renderBrainIcon(this.state.date_justification)}
                            </div>
                            <div className="dateEndTitle">
                                {t('End of campaign')}
                            </div>
                            <DateRangePicker
                                startDatePlaceholderText={t('Add dates')}
                                endDatePlaceholderText={t('Add dates')}
                                minimumNights={0}
                                startDate={
                                    this.state.start_date ? moment(this.state.start_date._d) : null
                                }
                                startDateId="your_unique_start_date_id"
                                endDate={
                                    this.state.end_date ? moment(this.state.end_date._d) : null
                                }
                                endDateId="your_unique_end_date_id"
                                onDatesChange={({ startDate, endDate }) =>
                                    this.setDates({ startDate, endDate })
                                }
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                hideKeyboardShortcutsPanel={true}
                                customArrowIcon={<div />}
                                orientation={
                                    window.matchMedia("(max-width: 600px)").matches
                                        ? VERTICAL_ORIENTATION
                                        : HORIZONTAL_ORIENTATION
                                }
                                numberOfMonths={
                                    window.matchMedia("(max-width: 600px)").matches ? 1 : 2
                                }
                                openDirection= {OPEN_UP}
                                daySize={30}
                            />
                        </Form.Item>
                    </Col>
                    <Row type="flex" justify="center" gutter={16} style={{ marginLeft: 0, width: '100%' }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className='marginInputModal' style={{ paddingLeft: 0 }}>
                            <Form.Item label={
                                <>
                                    <Icon type="dollar" className='iconAI' />
                                    {t("Currency")}
                                </>}>
                                <Select className='budgetSelect' defaultValue={t("Select")} onChange={(value) => this.setState({ currency: value })} value={this.state.currency} >
                                    {this.state.currencies && this.state.currencies.map((c, index) => (
                                        <Select.Option key={index} value={c.code} className='selectAI'>
                                            {c.code}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className='marginInputModal' style={{ paddingRight: 0 }}>
                            <Form.Item label={
                                <>
                                    <Icon type="dollar" className='iconAI' />
                                    {t("Budget")}
                                    {this.renderBrainIcon(this.state.budget_justification)}
                                </>}>
                                <span>
                                    <CSSEffect>
                                        <CSSTransition
                                            timeout={1000}
                                            classNames="my-node">
                                            <Form.Item
                                            >
                                                <Input
                                                    type="number"
                                                    min={getMinimunByCurrency(this.props.currency)}
                                                    max={999999999999.99}
                                                    autoComplete="budgetInput"
                                                    placeholder="0.00"
                                                    className="budgetInput"
                                                    onChange={(e) => this.handleFormChange(e, 'campaign_amount', t)}
                                                    value={this.state.campaign_amount}
                                                />
                                            </Form.Item>
                                        </CSSTransition>
                                    </CSSEffect>
                                </span>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            ),
        },
        {
            title: t('Segmentation'),
            subtitle: t("Define your audience's demographics and points of interest"),
            content: (
                <Form layout="vertical">
                    <Row type="flex" justify="center" gutter={16} style={{ marginLeft: 0, width: '100%' }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className='marginInputModal' style={{ paddingLeft: 0 }}>
                            <Form.Item label={
                                <>
                                    <Icon type="man" className='iconAI' />
                                    {t("Men") + " (%)"}
                                    {this.renderBrainIcon(this.state.audience_justification)}
                                </>}>
                                <Input
                                    type="number"
                                    max={100}
                                    autoComplete="budgetInput"
                                    placeholder="0.00%"
                                    className="budgetInput"
                                    onChange={(e) => this.handleFormChange(e, 'male_percentage', t)}
                                    value={this.state.male_percentage}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} className='marginInputModal' style={{ paddingRight: 0 }}>
                            <Form.Item label={
                                <>
                                    <Icon type="woman" className='iconAI' />
                                    {t("Women") + " (%)"}
                                    {this.renderBrainIcon(this.state.audience_justification)}
                                </>}>
                                <Input
                                    type="number"
                                    max={100}
                                    autoComplete="budgetInput"
                                    placeholder="0.00%"
                                    className="budgetInput"
                                    onChange={(e) => this.handleFormChange(e, 'female_percentage', t)}
                                    value={this.state.female_percentage}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label={
                        <>
                            <Icon type="user" className='iconAI' />
                            {t("Ages") + " (%)"}
                            {this.renderBrainIcon(this.state.audience_justification)}
                        </>}>
                        <Row type="flex" justify="space-between" gutter={16} style={{ marginLeft: 0, width: '100%' }}>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("CHILDREN")}
                                        <Tooltip title={t("CHILDREN_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                    >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_children', t)}
                                        value={this.state.age_children}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("TEENS")}
                                        <Tooltip title={t("TEENS_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_teens', t)}
                                        value={this.state.age_teens}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("YOUNG_ADULTS")}
                                        <Tooltip title={t("YOUNG_ADULTS_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_young_adults', t)}
                                        value={this.state.age_young_adults}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingRight: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("MIDLIFE_ADULTS")}
                                        <Tooltip title={t("MIDLIFE_ADULTS_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_midlife_adults', t)}
                                        value={this.state.age_midlife_adults}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingRight: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("MATURE_ADULTS")}
                                        <Tooltip title={t("MATURE_ADULTS_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_mature_adults', t)}
                                        value={this.state.age_mature_adults}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingRight: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                        {t("SENIOR")}
                                        <Tooltip title={t("SENIOR_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleAgeFormChange(e, 'age_seniors', t)}
                                        value={this.state.age_seniors}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label={
                        <>
                            <Icon type="line-chart" className='iconAI' />
                            {t("Socioeconomic level") + " (%)"}
                            {this.renderBrainIcon(this.state.audience_justification)}
                        </>}>
                        <Row type="flex" justify="space-between" gutter={16} style={{ marginLeft: 0, width: '100%' }}>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                        <div style={{ 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            whiteSpace: 'nowrap' 
                                        }}>
                                            {t("Level")} A
                                            <Tooltip title={t("LEVEL_A_INFO")}>
                                                <Icon type="info-circle" className='iconInfoAI' />
                                            </Tooltip>
                                        </div>
                                    }>
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleLevelFormChange(e, 'socioeconomic_a_percentage', t)}
                                        value={this.state.socioeconomic_a_percentage}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap' 
                                    }}>
                                            {t("Level")} B
                                        <Tooltip title={t("LEVEL_B_INFO")}>
                                            <Icon type="info-circle" className='iconInfoAI' />
                                        </Tooltip>
                                    </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleLevelFormChange(e, 'socioeconomic_b_percentage', t)}
                                        value={this.state.socioeconomic_b_percentage}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingLeft: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            whiteSpace: 'nowrap' 
                                        }}>
                                            {t("Level")} C
                                            <Tooltip title={t("LEVEL_C_INFO")}>
                                                <Icon type="info-circle" className='iconInfoAI' />
                                            </Tooltip>
                                        </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleLevelFormChange(e, 'socioeconomic_c_percentage', t)}
                                        value={this.state.socioeconomic_c_percentage}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingRight: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            whiteSpace: 'nowrap' 
                                        }}>
                                            {t("Level")} D
                                            <Tooltip title={t("LEVEL_D_INFO")}>
                                                <Icon type="info-circle" className='iconInfoAI' />
                                            </Tooltip>
                                        </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleLevelFormChange(e, 'socioeconomic_d_percentage', t)}
                                        value={this.state.socioeconomic_d_percentage}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={4} xl={4} className='marginInputModal' style={{ paddingRight: 0 }}>
                                <Form.Item label={
                                    <div style={{ 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            whiteSpace: 'nowrap' 
                                        }}>
                                            {t("Level")} E
                                            <Tooltip title={t("LEVEL_E_INFO")}>
                                                <Icon type="info-circle" className='iconInfoAI' />
                                            </Tooltip>
                                        </div>}
                                >
                                    <Input
                                        type="number"
                                        max={100}
                                        autoComplete="budgetInput"
                                        placeholder="0.00%"
                                        className="budgetInput"
                                        onChange={(e) => this.handleLevelFormChange(e, 'socioeconomic_e_percentage', t)}
                                        value={this.state.socioeconomic_e_percentage}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="marginInputModal">
                        <Form.Item label={
                            <>
                                <Icon type="pushpin" className='iconAI' />
                                {t("Points of interest")}
                                {this.renderBrainIcon(this.state.location_justification)}
                            </>}>
                            <Select defaultValue={t("Select")} value={this.state.points_of_interest} onChange={this.handleScreenPOIChange} mode="multiple" showSearch
                                filterOption={(inputValue, option) => {
                                    const input = inputValue.toLowerCase();

                                    const nameEn = option.props.name_en.toLowerCase();
                                    const nameEs = option.props.name_es.toLowerCase();

                                    return nameEn.includes(input) || nameEs.includes(input);
                                }}>
                                {this.props.campaign_POI && this.props.campaign_POI.map((poi, index) => (
                                    <Select.Option key={index} value={poi.type} name_en={poi.label_en} name_es={poi.label_es} className='selectAI'>{this.props.i18n.language === 'en' ? poi.label_en : poi.label_es}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Form>
            ),
        },
        {
            title: t('Types of screens'),
            subtitle: t("Define your audience's demographics and points of interest"),
            content: (
                <Form layout="vertical">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="marginInputModal">
                        <Form.Item label={
                            <>
                                <Icon type="desktop" className='iconAI' />
                                {t("Types")}
                                {this.renderBrainIcon(this.state.location_justification)}
                            </>}>
                            <Select placeholder={t("Select")} value={this.state.screen_types} mode="multiple" onChange={this.handleScreenTypesChange}>
                                <Select.Option value="outdoor" className='selectAI'>Outdoor</Select.Option>
                                <Select.Option value="indoor" className='selectAI'>Indoor</Select.Option>
                                <Select.Option value="pos" className='selectAI'>Pos</Select.Option>
                                <Select.Option value="buses" className='selectAI'>Buses</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="marginInputModal">
                        <Form.Item label={
                            <>
                                <Icon type="desktop" className='iconAI' />
                                {"Sub" + t("types")}
                            </>}>
                            <Select placeholder={t("Select")} value={this.state.screen_subtypes} mode="multiple" onChange={this.handleScreenSubtypesChange} showSearch
                                filterOption={(inputValue, option) => {
                                    const input = inputValue.toLowerCase();

                                    const nameEn = option.props.name_en.toLowerCase();
                                    const nameEs = option.props.name_es.toLowerCase();

                                    return nameEn.includes(input) || nameEs.includes(input);
                                }}
                            >
                                {this.props.campaign_screens && this.props.campaign_screens
                                    .filter(screen => 
                                        this.state.screen_types && this.state.screen_types.includes(screen.parent_latinad)
                                    )
                                    .map((screen, index) => (
                                        <Select.Option 
                                            key={index} 
                                            value={screen.name_en} 
                                            name_en={screen.name_en} 
                                            name_es={screen.name_es} className='selectAI'
                                        >
                                            {this.props.i18n.language === 'en' ? screen.name_en : screen.name_es}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Form>
            ),
        },
        {
            title: t('Proposals'),
            subtitle: '',
            content: (this.props.proposals && this.props.proposals.proposals && this.props.proposals.proposals.length) ? (
                <CampaignProposals 
                    proposals={this.props.proposals.proposals} 
                      cart={this.props.cart}
                      countries={this.props.countries}
                      history={this.props.history}
                      setCampaignName={this.props.setCampaignName}
                      setCampaignDescription={this.props.setCampaignDescription}
                      setCategoriesId={this.props.setCategoriesId}
                      setBilling={this.props.setBilling}
                      removeDisplaysCart={this.props.removeDisplaysCart}
                      setSelectedProposalId={this.props.setSelectedProposalId}
                      openChatbotWithGreeting={this.props.openChatbotWithGreeting}
                      currency={this.state.currency}
                      start_date={this.state.start_date}
                      end_date={this.state.end_date}
                      campaignZonesLatLng={this.state.campaign_zonesLatLng}
                />
            ) : (
                <div>t{'Loading'}...</div>
            ),
        },
    ];

    render() {
        const { t, visible, onCancel } = this.props;
        const { current } = this.state;
        const { steps } = this;

        return (
            <div className="customModalDiv">
                <style>{this.customStyles}</style>
                <Modal
                    visible={visible}
                    onCancel={() => {
                        this.setState({ current: 0, loading: false });
                        this.props.toggleCampaignFormModal(false);
                        this.props.clearPlanner();
                    }}
                    className='customModal'
                    width={'1250px'}
                    closable={true}
                    footer={this.state.isLoaderFinished ? (
                        <div className='footerDiv'>
                            <>
                                {current > 0 && (
                                    <Button style={{ margin: '0', display: 'flex', alignItems: 'center' }} className='btnAI' onClick={this.prev}>
                                        <Icon type="caret-left" className='btnActionAI' />
                                    </Button>
                                )}
                                {current === 0 && (
                                    <Button style={{ margin: '0', display: 'flex', alignItems: 'center' }} className='btnAI' onClick={onCancel}>
                                        <Icon type="caret-left" className='btnActionAI' />
                                    </Button>
                                )}
                                
                                {current < steps(t).length - 2 && (
                                    <Button style={{ display: 'flex', alignItems: 'center' }} className='btnAI' type="primary" onClick={this.next}>
                                        <Icon type="caret-right" className='btnActionAI' />
                                    </Button>
                                )}
                                {current === steps(t).length - 2 && (
                                    <Button
                                        type="primary"
                                        className='btnAI btnPropsAI'
                                        loading={this.props.loading}
                                        onClick={() => {
                                            this.props.clearProposals();
                                            const plannerFormAI = {
                                                start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
                                                end_date: moment(this.state.end_date).format('YYYY-MM-DD'),
                                                campaign_zones: this.state.campaign_zones,
                                                campaign_category: this.state.campaign_category,
                                                campaign_amount: this.state.campaign_amount,
                                                currency: this.state.currency,
                                                male_percentage: this.state.male_percentage,
                                                female_percentage: this.state.female_percentage,
                                                socioeconomic_a_percentage: this.state.socioeconomic_a_percentage,
                                                socioeconomic_b_percentage: this.state.socioeconomic_b_percentage,
                                                socioeconomic_c_percentage: this.state.socioeconomic_c_percentage,
                                                socioeconomic_d_percentage: this.state.socioeconomic_d_percentage,
                                                socioeconomic_e_percentage: this.state.socioeconomic_e_percentage,
                                                age_children: this.state.age_children,
                                                age_teens: this.state.age_teens,
                                                age_young_adults: this.state.age_young_adults,
                                                age_midlife_adults: this.state.age_midlife_adults,
                                                age_mature_adults: this.state.age_mature_adults,
                                                age_seniors: this.state.age_seniors,
                                                points_of_interest: this.state.points_of_interest,
                                                screen_types: this.state.screen_types,
                                                screen_subtypes: this.state.screen_subtypes,
                                            }
                                            this.handleCreateProposals(plannerFormAI, current);
                                        }}>
                                        {this.props.loading ? `${t('Creating proposals')}...` : t('Explore proposals')}
                                    </Button>
                                )}
                            </>
                        </div>
                        ):null
                    }
                    maskClosable={false}
                >
                    {this.state.isLoaderFinished ? (
                        <div className={this.props.planner && this.props.planner.id ? 'bodyDiv' : ''}>
                            <div className='modal-title'>
                                <img
                                    src={modalLogo}
                                    style={{maxHeight: "80px"}}
                                    alt=""
                                />
                            </div>
                            <Steps current={current} style={{marginBottom: '20px', display: current < 3 ? 'flex' : 'none'}}>
                                {steps(t).slice(0, steps(t).length - 1).map(item => ( 
                                    <Step key={item.title} title={item.title} />
                                ))}
                            </Steps>
                            <div className="steps-content">{steps(t)[current].content}</div>
                        </div>
                    ) : <AILoader onAnimationComplete={this.handleLoaderFinish} fullText={this.props.planner && this.props.planner.spinner_text ? this.props.planner.spinner_text : ''} t={t}/>}
                </Modal>
            </div>
        );
    }
    
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CampaignFormModal)));